import type { UnsignedDocRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: UnsignedDocRow[];
}

export function UnsignedDocsSection({ rows }: Props) {
  return (
    <CompSection title={`✍ Unsigned Documents (${rows.length})`} type="info">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Document</th>
              <th>Project</th>
              <th>Awaiting Signature From</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((d) => (
              <tr key={d.docId}>
                <td>{d.docName}</td>
                <td>{d.projectLabel}</td>
                <td style={{ color: 'var(--warn)' }}>{d.pendingNames.join(', ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="All shared documents signed" />
      )}
    </CompSection>
  );
}
